module.exports = __webpack_public_path__ + "static/img/9.1c626fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/sp/9.png
// module id = wFqR
// module chunks = 0